var _defs, _rect, _rect2, _rect3, _text, _path, _path2, _path3, _path4, _rect4, _text2, _path5, _path6, _rect5, _text3, _rect6, _text4, _path7, _path8, _rect7, _text5, _path9, _path0, _path1, _path10, _rect8, _text6, _rect9, _text7, _path11, _path12, _path13, _path14, _path15, _font, _text8, _rect0, _font2, _text9, _rect1, _font3, _text0, _path16, _path17, _ellipse, _text1, _switch;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagramaProcessoArquivoManual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "850px",
    height: "290px",
    viewBox: "-0.5 -0.5 850 290",
    className: "ge-export-svg-dark",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2023-11-09T12:34:15.677Z\" agent=\"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/119.0.0.0 Safari/537.36\" etag=\"_tV3p3bW9oyIqFL1yif6\" version=\"22.1.0\" type=\"device\"><diagram name=\"P\\xE1gina-1\" id=\"UNva-2gaQCidH6hSSF1b\">7Vtdc+I2FP01PLJjW7aJHwmE7E6b7c6k7e4+dYQtQI1sObJMIL++kixhG2MgWSA0gcyAdPVh6V7dc64lpQMG8eKWwXR2RyNEOo4VLTpg2HGcq54nvqVgWQjcnlMIpgxHhcguBff4GWmhpaU5jlBWq8gpJRyndWFIkwSFvCaDjNGnerUJJfWnpnCKGoL7EJKm9DuO+ExPy+mV8s8IT2fmybYfFCVjGD5MGc0T/byOAyz1KYpjaPrSgmwGI/pUEYGbDhgwSnmRihcDRKRqjdqKdqOW0tW4GUr4Pg0Wn58fBiC6s3OazvvB7eNsBLtmmnNIcmTmoUbLl0ZDao5I9mJ1wPXTDHN0n8JQlj6JJSFkMx4TkbNFcoIJGVBCmWprNAKuM87oAzIlCU1E8+vmFPSs5ohxtKiI9JRuEY0RZ0tR5aliLKBVPKsYyulpIdQLZLpqWypJJLSeNussmn99/Kf/rXsH8GAcOXjx23fafRuViZKR+vyi3ozfau0s695Y0WrP3aRV71haNSOoqdUnXCqIimlW9es/5tQUdDMFKX1RwfbThdKOKRepqfwdkXxBJUYh8dVPGZ3DzgB0+j31DVZFX5IpyviacCjcNhO/dzDJIc7MoMQki3EVjzjsEujLv61LQD67Ir/x5Z+QEzhG5HoFTWsOxyiHHNNESLqBpbvRmGz7Oj+CMSZyXfyNWAQTeJgF122suOaSW62u6pI7hB9vxL6gYTMUCWrQWcr4jE5pAslNKb2uW7Ws8zulqbblv4jzpdYpzDmtW7pVkxnNWYi2DNeQI2RTxLdBelFPzmWrXRgiYi3M6zR4cCWvpndSLQvlsuUP3V5lfsrMJ89kh4tq4XCpcw1/AyAItkPuO7Wb8e9WNA5XSirRFkzUpyraA7WdFtR+Mfy3dTSgMnKEokoiUT0VCwoSNQUUaXCXQJ8yhJJwJpNKZsoYmiBpdiQzkKq48zHHc5l6zGX1DDFFGrbUquAQEejSVp4oxGN2EN3sz0L2qwIR39/qFS10UWUVR3YgHin08qfyXqsUiJxzGHax/Tq7APuT16AX+2oDvfjesTyoGRZ+MORz9kQ+2z4r6HPeEfT9IYcLIyjNK5IKpQKp6mSOYUQLw0pkhJui4guCnQ7BQK+OYE7QwK8gOGF0DN6ZF2SU4BBzKHhcIUmIxjKRx9IbujHERUQgs9ItYsoLho+gqn5xj7d1D9/d6R5275Rvj7b3JvS+wPxHJV0hd5EruV1mDLWfU0jg7hkS+GcVEbgfEwuTCWYxTFSYcIkRzgAE199ybHPWsusl53go+CabaOeEaP6eiNY7K0RbHUpd7Pa/spt/PCZqwu9fMVTw9LzCfhUMwwqDrJGBmJQ1Fi+bssoEPiOmo+kQMoamMBZWUjG12lfTu2hZ0SwUHWquUbt0Y1o5iCnHlqeEwqg21gvTHOFt9MrbzTS9U76Pbjp1PdrKbwuSym3enbESzyHBz81zRqhAZyzQomO2j1MaVXrOlNeIHrOc8MLjksKHCoewiUDdjj6c1HvUFx84xiuntTvaWh2cnybaAh+dtc1W8U7aBmdF27b7toYrbfWzZqozNJx7aMPppt8oVjShndvz1pzbXnPaYka6VWn+PmNwWamWygrZtuf49ec4XrW7Rn1nfVz1+iJRjKBciyud/MLyfO1pL/LDsEkk95uDQ33zRjAaGO3NNTMaj/PsxTwDgN1vu0R1pa9XbSeQ492E8az6knDcZmhlbaCVq2PRivO6E68wRF49tiqM+HXX3lBrPPHCm1L6UtPBrxa28L/btNPGK3JHM9PrjmTazHSP42rg+NoY8Lxs5tlrcGs1rwGc1mj+Rw/ZNIHtcQ3grEI2M+yKt31JFLINQ0ybRiUEpxna7QwwS4tr7BO8kCZeZy67D8Bm5nKHQWCZS5sVubRQEBzGf4LdkGc3vcd9uRFEtrz6XsQx5b8XgJv/AA==</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "svg.ge-export-svg-dark &gt; * { filter: invert(100%) hue-rotate(180deg); }&#xa;svg.ge-export-svg-dark image { filter: invert(100%) hue-rotate(180deg) }"))), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 830,
    height: 270,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 20,
    width: 740,
    height: 250,
    fill: "#000000",
    stroke: "#ffffff",
    pointerEvents: "all"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: 110,
    width: 250,
    height: 70,
    fill: "#0a0a0a",
    stroke: "#ffffff",
    transform: "rotate(-90,55,145)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)rotate(-90 55 145)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 248,
      height: 1,
      paddingTop: 145,
      marginLeft: "-69px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #E6E6E6; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Verdana",
      color: "rgb(230, 230, 230)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 16
    }
  }, "Fluxo de Aprova\xE7\xE3o de Ingest\xE3o de Dados Manuais"))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 150,
    fill: "#E6E6E6",
    fontFamily: "Verdana",
    fontSize: "16px",
    textAnchor: "middle"
  }, "Fluxo de Aprova\xE7\xE3o de Ingest\xE3o...")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 350 74 L 370 74 L 360 74 L 373.63 74",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 378.88 74 L 371.88 77.5 L 373.63 74 L 371.88 70.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 350 74 L 370 74 L 360 74 L 373.63 74",
    fill: "none",
    stroke: "#3399ff",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 378.88 74 L 371.88 77.5 L 373.63 74 L 371.88 70.5 Z",
    fill: "#3399ff",
    stroke: "#3399ff",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 41.5,
    width: 180,
    height: 65,
    rx: 9.75,
    ry: 9.75,
    fill: "#000066",
    stroke: "#3399ff",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 178,
      height: 1,
      paddingTop: 74,
      marginLeft: 171
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Verdana",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    },
    color: "#ffffff"
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "Conecta no portal coedados e preenche os dados referentes ao arquivo que ser\xE1 ingerido"), /*#__PURE__*/React.createElement("br", {
    style: {
      fontSize: 12
    }
  })))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 78,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Verdana",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Conecta no portal coedados e p...")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 479 74 L 499 74 L 496 74 L 509.63 74",
    fill: "none",
    stroke: "#3399ff",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 514.88 74 L 507.88 77.5 L 509.63 74 L 507.88 70.5 Z",
    fill: "#3399ff",
    stroke: "#3399ff",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 39,
    width: 99,
    height: 70,
    rx: 10.5,
    ry: 10.5,
    fill: "#000066",
    stroke: "#3399ff",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 97,
      height: 1,
      paddingTop: 74,
      marginLeft: 381
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Verdana",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    },
    color: "#ffffff"
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "O cadastro \xE9 enviado para aprova\xE7\xE3o"), /*#__PURE__*/React.createElement("br", {
    style: {
      fontSize: 12
    }
  })))))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 78,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Verdana",
    fontSize: "12px",
    textAnchor: "middle"
  }, "O cadastro \xE9 env...")))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 39,
    width: 170,
    height: 70,
    rx: 10.5,
    ry: 10.5,
    fill: "#000066",
    stroke: "#3399ff",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 168,
      height: 1,
      paddingTop: 74,
      marginLeft: 651
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Verdana",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    },
    color: "#ffffff"
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "O solicitante recebe um e-mail com o motivo da reprova\xE7\xE3o"), /*#__PURE__*/React.createElement("br", {
    style: {
      fontSize: 12
    }
  })))))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 735,
    y: 78,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Verdana",
    fontSize: "12px",
    textAnchor: "middle"
  }, "O solicitante recebe um e-ma...")))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 350 217 L 388.63 217",
    fill: "none",
    stroke: "#3399ff",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 393.88 217 L 386.88 220.5 L 388.63 217 L 386.88 213.5 Z",
    fill: "#3399ff",
    stroke: "#3399ff",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 182,
    width: 180,
    height: 70,
    rx: 10.5,
    ry: 10.5,
    fill: "#000066",
    stroke: "#3399ff",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 178,
      height: 1,
      paddingTop: 217,
      marginLeft: 171
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Verdana",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    },
    color: "#ffffff"
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "O solicitante recebe um e-mail confirmando a aprova\xE7\xE3o"), /*#__PURE__*/React.createElement("br", {
    style: {
      fontSize: 12
    }
  })))))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 221,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Verdana",
    fontSize: "12px",
    textAnchor: "middle"
  }, "O solicitante recebe um e-mail...")))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 574 217 L 594 217 L 590 217 L 603.63 217",
    fill: "none",
    stroke: "#3399ff",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M 608.88 217 L 601.88 220.5 L 603.63 217 L 601.88 213.5 Z",
    fill: "#3399ff",
    stroke: "#3399ff",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M 574 217 L 594 217 L 590 217 L 603.63 217",
    fill: "none",
    stroke: "#3399ff",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 608.88 217 L 601.88 220.5 L 603.63 217 L 601.88 213.5 Z",
    fill: "#3399ff",
    stroke: "#3399ff",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 182,
    width: 179,
    height: 70,
    rx: 10.5,
    ry: 10.5,
    fill: "#000066",
    stroke: "#3399ff",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 177,
      height: 1,
      paddingTop: 217,
      marginLeft: 396
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Verdana",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {},
    color: "#ffffff"
  }, "Uma vez aprovada a solicita\xE7\xE3o, basta fazer o carregamento dos arquivos, clicando no bot\xE3o \"upload\"", /*#__PURE__*/React.createElement("br", {
    style: {
      fontSize: 12
    }
  })))))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 485,
    y: 221,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Verdana",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Uma vez aprovada a solicita\xE7\xE3o...")))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 182,
    width: 210,
    height: 70,
    rx: 10.5,
    ry: 10.5,
    fill: "#000066",
    stroke: "#3399ff",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 208,
      height: 1,
      paddingTop: 217,
      marginLeft: 611
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Verdana",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {},
    color: "#ffffff"
  }, "O solicitante receber\xE1 um e-mail confirmando a atualiza\xE7\xE3o da tabela que poder\xE1 ser consultada no cat\xE1logo de dados", /*#__PURE__*/React.createElement("br", {
    style: {
      fontSize: 12
    }
  })))))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 715,
    y: 221,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Verdana",
    fontSize: "12px",
    textAnchor: "middle"
  }, "O solicitante receber\xE1 um e-mail co...")))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 616 74 L 636 74 L 630 74 L 643.63 74",
    fill: "none",
    stroke: "#3399ff",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 648.88 74 L 641.88 77.5 L 643.63 74 L 641.88 70.5 Z",
    fill: "#3399ff",
    stroke: "#3399ff",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 566 114 L 566 135 L 260 135 L 260 175.63",
    fill: "none",
    stroke: "#3399ff",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 260 180.88 L 256.5 173.88 L 260 175.63 L 263.5 173.88 Z",
    fill: "#3399ff",
    stroke: "#3399ff",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 566 34 L 616 74 L 566 114 L 516 74 Z",
    fill: "#331a00",
    stroke: "#ff8000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 98,
      height: 1,
      paddingTop: 74,
      marginLeft: 517
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Verdana",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _font || (_font = /*#__PURE__*/React.createElement("font", {
    color: "#ffe6cc"
  }, "Solicita\xE7\xE3o Aprovada?")))))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 566,
    y: 78,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Verdana",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Solicita\xE7\xE3o Apro...")))), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 54,
    width: 40,
    height: 20,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 64,
      marginLeft: 611
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _font2 || (_font2 = /*#__PURE__*/React.createElement("font", {
    color: "#cce5ff"
  }, "N\xE3o")))))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 68,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "N\xE3o")))), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 115,
    width: 40,
    height: 20,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 125,
      marginLeft: 527
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _font3 || (_font3 = /*#__PURE__*/React.createElement("font", {
    color: "#cce5ff"
  }, "Sim", /*#__PURE__*/React.createElement("br", null))))))), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 546,
    y: 129,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Sim&#xa;")))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 141 74.5 L 161 74.5 L 163.64 74.35",
    fill: "none",
    stroke: "#3399ff",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 168.88 74.06 L 162.09 77.94 L 163.64 74.35 L 161.7 70.96 Z",
    fill: "#3399ff",
    stroke: "#3399ff",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.5,
    cy: 74.5,
    rx: 20.5,
    ry: 20.5,
    fill: "#1a3300",
    stroke: "#4d9900",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 39,
      height: 1,
      paddingTop: 75,
      marginLeft: 101
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #99FF99; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(153, 255, 153)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "In\xEDcio")))), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 121,
    y: 78,
    fill: "#99FF99",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "In\xEDcio"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.drawio.com/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramaProcessoArquivoManual);
export default __webpack_public_path__ + "static/media/diagrama_processo_arquivo_manual.66509942b917036e4abcd0e0de6b4505.svg";
export { ForwardRef as ReactComponent };